import Store from '@/store';

export function setProgress(progress: boolean) {
  Store.commit('setProgress', progress);
}
